(function($){

	$.fn.toggleable = function() {

		return this.each(function()
		{
			var $panel = $(this);
			$panel.addClass("qui-toggleable").addClass("initted");
			/////alert($panel.html());
			var sLabel = $panel.data("qui-toggleable-title");
			var sCookieName = $panel.data("qui-toggleable-cookie");
			var $switcher = $
				(
					'\
						<div class="qui-toggleable-switcher ">\
							<div class="qui-toggleable-switcher-label">\
								<label>'+sLabel+'</label>\
							</div>\
							<div class="qui-toggleable-switcher-control">\
								<label class="on-qui-toggleable-shown">Скрыть</label>\
								<label class="on-qui-toggleable-hidden">Показать</label>\
							</div>\
							<hr>\
					 	</div>\
					'
				);

			if($panel.is(".qui-toggleable-is-hidden")) $switcher.addClass("qui-toggleable-is-hidden");

			$switcher.click(function()
			{
				if($panel.is(".qui-toggleable-is-hidden")) // тогда показываем
				{
					$panel.removeClass("qui-toggleable-is-hidden");
					$switcher.removeClass("qui-toggleable-is-hidden");
					$.cookie(sCookieName, 1, { expires: 7 }, "/");

					$panel.trigger("shown.toggleable");
				}
				else // тогда скрываем
				{
					$panel.addClass("qui-toggleable-is-hidden");
					$switcher.addClass("qui-toggleable-is-hidden");
					$.cookie(sCookieName, 0, { expires: 7 }, "/");

					$panel.trigger("hidden.toggleable");
				}
			});

			$panel.before($switcher);

			$.cookie(sCookieName, $.cookie(sCookieName), { expires: 7 }, "/"); // обновим время куки.

		});

	};

})(jQuery);